var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 215,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.93277771 -0.00540298 1.86555542 -0.01080597 2.82659912 -0.01637268 C5.89839825 -0.0288376 8.96925531 -0.0123732 12.04101562 0.00561523 C14.19226124 0.00546009 16.34350713 0.00396856 18.49475098 0.00120544 C23.00378786 -0.00017792 27.51250646 0.01236112 32.02148438 0.03515625 C37.76286807 0.06340352 43.50371774 0.06083981 49.24514008 0.04806614 C53.69108524 0.04106001 58.13691017 0.04895641 62.58283997 0.06132317 C64.69724565 0.0657996 66.81166443 0.06620828 68.92607117 0.06225777 C89.92616285 0.04140346 109.34906639 2.00313064 126.44726562 15.50170898 C127.04410156 15.96963867 127.6409375 16.43756836 128.25585938 16.91967773 C134.13071709 21.68109608 139.14542397 26.02314342 140.13476562 33.81420898 C140.23789063 35.03108398 140.34101563 36.24795898 140.44726562 37.50170898 C141.10726562 37.50170898 141.76726562 37.50170898 142.44726562 37.50170898 C142.11726562 44.43170898 141.78726563 51.36170898 141.44726562 58.50170898 C133.44726562 56.56420898 133.44726562 56.56420898 130.97851562 55.95898438 C130.30820313 55.79906006 129.63789063 55.63913574 128.94726562 55.47436523 C128.27695313 55.31202393 127.60664063 55.14968262 126.91601562 54.98242188 C120.75303864 53.78237226 114.69571141 53.35236256 108.42651367 53.35644531 C107.66938583 53.3530867 106.912258 53.34972809 106.13218689 53.3462677 C103.65776889 53.33685473 101.1834191 53.33482029 98.70898438 53.33374023 C96.97882561 53.3305237 95.24866712 53.32715933 93.51850891 53.32365417 C89.90678272 53.31768915 86.29508038 53.31581184 82.68334961 53.31640625 C78.05182845 53.31650836 73.4204589 53.3027941 68.78897381 53.28563404 C65.22283724 53.2745349 61.65673778 53.27248631 58.09058571 53.27301598 C56.38212366 53.2718351 54.67366068 53.26740731 52.96521568 53.25968361 C50.5837153 53.2499148 48.2025504 53.25274801 45.82104492 53.25878906 C45.1150415 53.25316956 44.40903809 53.24755005 43.68164062 53.24176025 C40.03641257 53.26532421 38.57142191 53.41893813 35.44726562 55.50170898 C34.06602599 57.46892907 32.73238436 59.47039227 31.44726562 61.50170898 C30.78726563 62.49170898 30.12726563 63.48170898 29.44726562 64.50170898 C27.82884614 69.46878638 26.84335109 74.46890423 26.02685547 79.61743164 C25.83622276 80.78733139 25.83622276 80.78733139 25.64173889 81.98086548 C25.22591219 84.54177497 24.81660148 87.10366755 24.40820312 89.66577148 C24.11968297 91.46309748 23.83107679 93.26040967 23.54238892 95.05770874 C22.93914575 98.8212575 22.33961293 102.58537713 21.7421875 106.34985352 C20.98093711 111.1422961 20.20646945 115.93249831 19.42860985 120.72226906 C18.82801795 124.43439603 18.2366657 128.14795367 17.64775467 131.86194992 C17.36639508 133.6268707 17.08178323 135.39127655 16.7936821 137.15510941 C15.33957927 146.0795933 14.10315298 154.66040819 14.44741821 163.73861694 C14.44725149 166.75772344 14.01482456 169.5410474 13.44726562 172.50170898 C12.78726563 172.50170898 12.12726562 172.50170898 11.44726562 172.50170898 C10.86366407 178.84837584 10.3023508 185.12545676 10.44726562 191.50170898 C9.78726563 191.50170898 9.12726562 191.50170898 8.44726562 191.50170898 C8.27738882 193.37642087 8.11151786 195.25149594 7.94726562 197.12670898 C7.85445312 198.17084961 7.76164062 199.21499023 7.66601562 200.29077148 C7.45602207 203.37317687 7.41016836 206.41336127 7.44726562 209.50170898 C6.78726563 209.83170898 6.12726562 210.16170898 5.44726562 210.50170898 C4.8081387 213.36605303 4.27782019 216.1705078 3.82226562 219.06420898 C3.68820313 219.87051758 3.55414063 220.67682617 3.41601562 221.50756836 C3.08519264 223.50432138 2.76521525 225.50286569 2.44726562 227.50170898 C-4.01215169 227.60322455 -10.47136289 227.67322274 -16.93139648 227.72143555 C-19.12841479 227.74153665 -21.3253797 227.76882204 -23.5222168 227.8034668 C-26.68226304 227.85204992 -29.84160124 227.87469303 -33.00195312 227.89233398 C-34.47253426 227.9233017 -34.47253426 227.9233017 -35.9728241 227.95489502 C-40.26346846 227.95630317 -42.87635249 227.87767026 -46.6809082 225.76293945 C-49.49081779 222.36847192 -49.11414793 220.25310389 -48.91601562 215.98901367 C-48.04616075 207.63887451 -46.5522613 199.38125605 -45.11621094 191.11352539 C-43.39546868 181.13048896 -42.05900009 171.66669208 -42.55273438 161.50170898 C-41.89273438 161.50170898 -41.23273437 161.50170898 -40.55273438 161.50170898 C-39.96913282 155.15504213 -39.40781955 148.8779612 -39.55273438 142.50170898 C-38.89273438 142.50170898 -38.23273437 142.50170898 -37.55273438 142.50170898 C-33.98499755 123.62645149 -33.98499755 123.62645149 -33.55273438 104.50170898 C-32.89273438 104.50170898 -32.23273437 104.50170898 -31.55273438 104.50170898 C-30.68483546 99.33009325 -29.83099787 94.15640663 -28.98925781 88.98046875 C-28.70195264 87.22562547 -28.41103274 85.47136954 -28.11621094 83.71777344 C-26.41002496 73.55319947 -25.04493967 63.83979794 -25.55273438 53.50170898 C-24.89273437 53.50170898 -24.23273437 53.50170898 -23.55273438 53.50170898 C-22.96913282 47.15504213 -22.40781955 40.8779612 -22.55273438 34.50170898 C-21.89273437 34.50170898 -21.23273437 34.50170898 -20.55273438 34.50170898 C-19.96913282 28.15504213 -19.40781955 21.8779612 -19.55273438 15.50170898 C-18.89273437 15.50170898 -18.23273437 15.50170898 -17.55273438 15.50170898 C-17.56175781 14.75405273 -17.57078125 14.00639648 -17.58007812 13.23608398 C-17.53560547 11.75881836 -17.53560547 11.75881836 -17.49023438 10.25170898 C-17.47863281 9.27717773 -17.46703125 8.30264648 -17.45507812 7.29858398 C-16.34476598 3.857097 -14.78536601 2.99613498 -11.66693115 1.32734489 C-7.83835909 -0.16778868 -4.06394126 -0.04528384 0 0 Z M12.44726562 159.50170898 C12.44726562 161.48170898 12.44726562 163.46170898 12.44726562 165.50170898 C12.77726562 165.50170898 13.10726562 165.50170898 13.44726562 165.50170898 C13.44726562 163.52170898 13.44726562 161.54170898 13.44726562 159.50170898 C13.11726563 159.50170898 12.78726563 159.50170898 12.44726562 159.50170898 Z ",
    fill: "#FFFFFF",
    transform: "translate(48.552734375,-0.501708984375)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.91304348 3.56521739 8.91304348 3.56521739 11 8 C11.680625 8.61875 12.36125 9.2375 13.0625 9.875 C15.5379984 12.59006276 15.57485415 14.38626027 16 18 C16.49886719 19.485 16.49886719 19.485 17.0078125 21 C18.4684781 25.99926277 18.29750805 31.01837136 18.25 36.1875 C18.24540771 37.209646 18.24081543 38.23179199 18.23608398 39.28491211 C18.15100477 46.36226333 17.54092689 53.08270048 16 60 C15.78150391 61.54494141 15.78150391 61.54494141 15.55859375 63.12109375 C15 66 15 66 13 69 C12.3162955 70.32467746 11.65035814 71.65863633 11 73 C10.649375 73.66 10.29875 74.32 9.9375 75 C8.94099845 76.93354634 8.94099845 76.93354634 8.5859375 78.8984375 C7.94589674 81.19405037 7.06498879 82.68883928 5.6875 84.625 C5.07455078 85.51058594 5.07455078 85.51058594 4.44921875 86.4140625 C2.78426249 88.2360901 1.19839972 88.90915908 -1 90 C-2.22749834 91.18922445 -3.4124672 92.42320909 -4.5625 93.6875 C-20.3384286 109.75449739 -42.19957396 113.181976 -63.72631836 113.62207031 C-64.62745361 113.64495117 -65.52858887 113.66783203 -66.45703125 113.69140625 C-67.6632312 113.70989624 -67.6632312 113.70989624 -68.89379883 113.72875977 C-71.30151365 113.88042793 -71.30151365 113.88042793 -74 116 C-74.93586445 118.14875914 -74.93586445 118.14875914 -75.5625 120.5625 C-76.25390625 123.00390625 -76.25390625 123.00390625 -77 125 C-77.99 125.495 -77.99 125.495 -79 126 C-81.15897382 133.84960236 -81.25786805 141.92013444 -81 150 C-81.66 150.33 -82.32 150.66 -83 151 C-84.65961564 157.03403464 -85.10127385 163.14379503 -84.9375 169.375 C-84.86469924 174.00998186 -85.08772982 177.18392183 -88 181 C-90.5625 182.3125 -90.5625 182.3125 -93 183 C-93.66 183.33 -94.32 183.66 -95 184 C-98.00386802 184.11155992 -100.98382371 184.16412933 -103.98828125 184.16796875 C-104.88363083 184.17129715 -105.77898041 184.17462555 -106.70146179 184.17805481 C-108.59873948 184.18312347 -110.4960261 184.18546315 -112.39331055 184.18530273 C-115.29035251 184.18748333 -118.18701012 184.20562333 -121.08398438 184.22460938 C-122.92708203 184.22754452 -124.7701815 184.2295285 -126.61328125 184.23046875 C-127.91039787 184.24124702 -127.91039787 184.24124702 -129.23371887 184.25224304 C-133.60799799 184.23571019 -137.01876282 184.05081721 -141 182 C-140.3834579 177.64460629 -139.75668435 173.29072009 -139.125 168.9375 C-139.02273102 168.2323526 -138.92046204 167.5272052 -138.81509399 166.8006897 C-137.11750861 155.14905909 -135.3003174 143.51742515 -133.44140625 131.890625 C-133.3290287 131.1870241 -133.21665115 130.48342319 -133.10086823 129.75850105 C-131.95456627 122.58215533 -130.80459457 115.40642761 -129.64395618 108.23238564 C-129.309369 106.16085659 -128.97648104 104.08906251 -128.64427185 102.01715088 C-128.2316653 99.44522507 -127.81600666 96.8737865 -127.39686584 94.30291748 C-127.12053566 92.57455658 -127.12053566 92.57455658 -126.83862305 90.8112793 C-126.67605515 89.80574509 -126.51348724 88.80021088 -126.34599304 87.76420593 C-125.92804198 85.0077614 -125.92804198 85.0077614 -126.08821106 82.24226379 C-126.05910141 81.50231674 -126.02999176 80.76236969 -126 80 C-123.75 78.3125 -123.75 78.3125 -121 77 C-120.14643921 76.47394165 -120.14643921 76.47394165 -119.27563477 75.93725586 C-116.08514853 74.62320408 -113.28447111 74.7245131 -109.83984375 74.69140625 C-108.40103408 74.6688546 -106.96223215 74.64580498 -105.5234375 74.62231445 C-104.77416992 74.61318024 -104.02490234 74.60404602 -103.25292969 74.59463501 C-77.45564595 74.23660386 -52.48269911 71.69121449 -31 56 C-29.24212694 54.01167154 -29.24212694 54.01167154 -28 52 C-25.15011625 48.34630289 -23.09284633 46.04642316 -19 44 C-18.62243192 42.67851173 -18.2981424 41.34164079 -18 40 C-16.0625 36.75 -16.0625 36.75 -14 34 C-13.34 34 -12.68 34 -12 34 C-11.89558594 33.17113281 -11.79117188 32.34226563 -11.68359375 31.48828125 C-10.89879259 27.48355305 -9.5951775 23.95487276 -8.0625 20.1875 C-7.79759766 19.50751953 -7.53269531 18.82753906 -7.25976562 18.12695312 C-5.25000975 13.12500487 -5.25000975 13.12500487 -3 12 C-2.08514427 9.19521805 -2.08514427 9.19521805 -1.375 5.9375 C-1.11460937 4.83277344 -0.85421875 3.72804688 -0.5859375 2.58984375 C-0.39257812 1.73519531 -0.19921875 0.88054687 0 0 Z M-5 16 C-4 18 -4 18 -4 18 Z M-7 21 C-6 23 -6 23 -6 23 Z M-8 24 C-7 26 -7 26 -7 26 Z M14 61 C15 63 15 63 15 63 Z M13 64 C14 66 14 66 14 66 Z M-87 170 C-87 171.65 -87 173.3 -87 175 C-86.67 175 -86.34 175 -86 175 C-86 173.35 -86 171.7 -86 170 C-86.33 170 -86.66 170 -87 170 Z M-88 176 C-87 178 -87 178 -87 178 Z ",
    fill: "#FFFFFF",
    transform: "translate(197,71)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.67568024 -0.00511093 1.35136047 -0.01022186 2.04751587 -0.01548767 C4.27623439 -0.02935458 6.50464193 -0.02842667 8.73339844 -0.02612305 C10.29978548 -0.0300165 11.86617149 -0.0343525 13.43255615 -0.03910828 C16.72102264 -0.04656792 20.00938183 -0.04628469 23.29785156 -0.04101562 C27.46297599 -0.0352741 31.62764798 -0.05202268 35.79269791 -0.0753603 C39.03430652 -0.09028559 42.27581152 -0.09094333 45.51744843 -0.08785057 C47.04966871 -0.08835618 48.58189602 -0.09344686 50.11408234 -0.10366249 C64.5075149 -0.1877283 78.41698516 1.5368544 92.09277344 6.2746582 C91.76277344 8.2546582 91.43277344 10.2346582 91.09277344 12.2746582 C90.43277344 12.2746582 89.77277344 12.2746582 89.09277344 12.2746582 C88.00959175 17.5959197 86.93989943 22.90952689 86.09277344 28.2746582 C85.43277344 28.2746582 84.77277344 28.2746582 84.09277344 28.2746582 C84.01542969 29.28012695 83.93808594 30.2855957 83.85839844 31.3215332 C83.22253427 35.73700953 81.29131157 38.86373711 78.84277344 42.5246582 C78.45992188 43.13567383 78.07707031 43.74668945 77.68261719 44.3762207 C75.22687388 48.13786096 73.00628261 50.16173072 69.09277344 52.2746582 C67.50074697 53.67938744 65.93917293 55.11917835 64.40527344 56.5871582 C49.31896895 70.23772361 29.21721461 75.43912222 9.17480469 75.6887207 C8.19154709 75.70808685 7.20828949 75.727453 6.19523621 75.74740601 C3.09866623 75.80650397 0.00205765 75.85330422 -3.09472656 75.8996582 C-5.21258004 75.9379024 -7.33041903 75.97695772 -9.44824219 76.0168457 C-14.60111735 76.1121468 -19.75406508 76.19643064 -24.90722656 76.2746582 C-24.90722656 71.3246582 -24.90722656 66.3746582 -24.90722656 61.2746582 C-24.24722656 61.2746582 -23.58722656 61.2746582 -22.90722656 61.2746582 C-22.32362501 54.92799135 -21.76231174 48.65091042 -21.90722656 42.2746582 C-21.24722656 42.2746582 -20.58722656 42.2746582 -19.90722656 42.2746582 C-19.91882813 41.40583008 -19.93042969 40.53700195 -19.94238281 39.6418457 C-19.95140625 38.48942383 -19.96042969 37.33700195 -19.96972656 36.1496582 C-19.98132813 35.01270508 -19.99292969 33.87575195 -20.00488281 32.7043457 C-19.91255357 29.4617426 -19.52112562 26.45533208 -18.90722656 23.2746582 C-18.24722656 23.2746582 -17.58722656 23.2746582 -16.90722656 23.2746582 C-16.91882813 22.42000977 -16.93042969 21.56536133 -16.94238281 20.68481445 C-16.95140625 19.58008789 -16.96042969 18.47536133 -16.96972656 17.3371582 C-16.98132813 16.23500977 -16.99292969 15.13286133 -17.00488281 13.99731445 C-16.90722656 11.2746582 -16.90722656 11.2746582 -15.90722656 10.2746582 C-15.78347656 9.4909082 -15.65972656 8.7071582 -15.53222656 7.8996582 C-14.83061605 4.95289405 -14.29925602 4.0686803 -11.90722656 2.2746582 C-7.84239587 0.28698801 -4.5010484 0.01704463 0 0 Z M-14.90722656 7.2746582 C-13.90722656 10.2746582 -13.90722656 10.2746582 -13.90722656 10.2746582 Z M85.09277344 23.2746582 C86.09277344 25.2746582 86.09277344 25.2746582 86.09277344 25.2746582 Z M-18.90722656 30.2746582 C-18.90722656 32.2546582 -18.90722656 34.2346582 -18.90722656 36.2746582 C-18.57722656 36.2746582 -18.24722656 36.2746582 -17.90722656 36.2746582 C-17.90722656 34.2946582 -17.90722656 32.3146582 -17.90722656 30.2746582 C-18.23722656 30.2746582 -18.56722656 30.2746582 -18.90722656 30.2746582 Z ",
    fill: "#FFFFFF",
    transform: "translate(98.9072265625,60.725341796875)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C25.74 0 51.48 0 78 0 C78 0.33 78 0.66 78 1 C52.26 1 26.52 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(87,53)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C23.76 0 47.52 0 72 0 C72 0.33 72 0.66 72 1 C48.24 1 24.48 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(92,59)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C14.85 0 29.7 0 45 0 C45 0.33 45 0.66 45 1 C30.15 1 15.3 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(5,228)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.89 0 21.78 0 33 0 C33 0.33 33 0.66 33 1 C22.11 1 11.22 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(80,144)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.26 0 14.52 0 22 0 C22 0.33 22 0.66 22 1 C14.74 1 7.48 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(126,185)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 4.95 1 9.9 1 15 C0.67 15 0.34 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(191,42)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 0.33 13 0.66 13 1 C8.71 1 4.42 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(106,137)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 0.33 8 0.66 8 1 C5.36 1 2.72 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(114,143)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 0.33 8 0.66 8 1 C5.36 1 2.72 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(164,60)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 0.33 8 0.66 8 1 C5.36 1 2.72 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(165,54)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(55,244)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(57,231)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(60,212)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(0,199)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(3,180)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(65,140)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(119,136)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(17,91)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(75,77)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(56,238)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(112,234)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(113,228)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(58,225)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(114,222)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(59,219)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(53,216)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(54,210)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(116,209)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(61,206)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(117,203)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(62,200)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(118,197)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(56,197)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(63,194)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(1,193)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(57,191)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(64,187)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(2,187)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(149,184)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(65,181)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(59,178)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(66,175)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(4,174)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(60,172)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(67,168)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(5,168)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(68,162)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(69,156)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(7,155)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(63,153)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(8,149)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(64,147)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(10,136)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(66,134)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(11,130)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(73,129)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(67,128)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(12,123)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(68,122)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(13,117)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(75,116)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(69,115)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(14,111)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(76,110)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(70,109)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(71,103)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(16,98)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(78,97)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(72,96)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(73,90)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(18,85)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(74,84)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(19,79)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(81,78)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(20,73)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(76,71)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(21,66)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(77,65)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(22,60)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(173,55)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(24,47)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(25,41)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(27,28)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(28,22)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(30,9)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(155,183)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(123,142)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(128,141)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 0.33 5 0.66 5 1 C3.35 1 1.7 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(173,61)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#FFFFFF",
    transform: "translate(52,222)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(160,182)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(133,140)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(126,135)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(130,134)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(134,133)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#FFFFFF",
    transform: "translate(214,124)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#FFFFFF",
    transform: "translate(194,76)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#FFFFFF",
    transform: "translate(188,73)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#FFFFFF",
    transform: "translate(195,72)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(179,56)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(148,1)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(144,0)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(164,181)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(167,180)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(77,145)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(137,139)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(140,138)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(75,138)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(143,137)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(148,135)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(140,131)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(182,63)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(178,62)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(186,58)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(183,57)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(84,54)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(158,4)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(155,3)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(152,2)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(102,255)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(59,255)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(3,227)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(123,186)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(170,179)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(172,178)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(175,177)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(178,175)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(180,174)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(183,172)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(186,170)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(146,136)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(151,134)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(153,133)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(138,132)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(158,130)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(143,130)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(145,129)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(161,128)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(164,126)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(151,126)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(153,125)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(156,123)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(160,120)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(198,70)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(185,64)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(88,61)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(90,60)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(171,11)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(168,9)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(165,7)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(163,6)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FFFFFF",
    transform: "translate(161,5)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.837b91f65080d24e2c9ef5e8e0b68fc9.svg";
export { ForwardRef as ReactComponent };